import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import ButtonCustom from '../../commonComponents/ButtonCustom';

const HandleReservations = (props) => {
  const { handleNewReservation } = props;

  return (
    <Row className="handle-reservations__form auto-margin justify-content-end">
      <Col sm="auto" className="no-padding">
        <ButtonCustom
          label={translate('nuevaReserva')}
          dataTestLabel="boton-nueva-reserva"
          colorClass="create-bttn"
          iconClass="create-icon"
          clickAction={handleNewReservation}
        />
      </Col>
    </Row>
  );
};

HandleReservations.propTypes = {
  handleNewReservation: PropTypes.func
};

HandleReservations.defaultProps = {
  handleNewReservation: () => {}
};

export default HandleReservations;
